import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Formik, Form } from 'formik';
import Button from '@material-ui/core/Button';
import * as Yup from 'yup';
import { Paper, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import { api } from '../../redux/services/api';
import GenericDialog from './GenericDialog';
import ContactSettings from '../ContactSettings';
import {
	getContentGrapesJSComponent,
	getColorHexUsingComputedStyle,
	getTitleFromSection,
	handleSaveInEditConfigurationDialog,
} from '../../utils';
import { contactFormYupSchema } from '../EditorLeftPanel';

const useStyles = makeStyles((theme) => ({
	boxContent: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.paper,

		'& .form-title': {
			marginBottom: '2rem',
		},
	},
	descriptionWrapper: {
		paddingBottom: theme.spacing(2),
	},
	eachComponent: {
		width: 300,
		marginBottom: theme.spacing(2.5),
		'& label': {
			marginBottom: theme.spacing(1),
			display: 'block',
		},
	},
	formWrapper: {
		'& .submitButton': {
			textAlign: 'right',
		},
	},
}));

const EditContactSectionDialog = (props) => {
	const { open, handleClose, sectionId } = props;
	const classes = useStyles();
	const contactForm = useStoreState((state) => state.template.contactForm);
	const loadTemplate = useStoreActions((actions) => actions.template.loadTemplate);
	const contactNumberElement = getContentGrapesJSComponent('.contact-number');
	console.log(contactForm, contactNumberElement);
	const handleSave = async (values) => {
		console.log('EditServicesDialog handleSave', values);
		// Save to DB
		const response = await api.post(
			`${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/save_sitesettings_details/`,
			{
				contact_form: values.contactForm,
			},
		);
		const responseStatus = response?.status;
		console.log('EditContactSectionDialog handleSave responseStatus', responseStatus);
		await loadTemplate();

		handleSaveInEditConfigurationDialog(values, sectionId);

		handleClose && handleClose();
	};

	const renderForm = () => {
		return (
			<Form className={classes.formWrapper}>
				<ContactSettings lightBackground {...props} />
				<Box p={1} pt={2}>
					<div className="submitButton">
						<Button
							variant="contained"
							color="primary"
							type="submit"
							// onClick={handleSave}
						>
							{_e('save')}
						</Button>
					</div>
				</Box>
			</Form>
		);
	};

	const title = getTitleFromSection(sectionId);
	const headerColorHex = getColorHexUsingComputedStyle('contact', 'header');
	const textColorHex = getColorHexUsingComputedStyle('contact', 'body');
	const buttonTextColorHex = getColorHexUsingComputedStyle('contact', 'buttonTextColor', {
		defaultColorHex: '#ffffff',
	});
	const buttonBackgroundColorHex = getColorHexUsingComputedStyle(
		'contact',
		'buttonBackgroundColor',
		{
			colorProperty: 'background-color',
		},
	);
	const socialIconsColorHex = getColorHexUsingComputedStyle('contact', 'socialIcons');

	const contactFormInitialValues = {
		...contactForm,
		headerColor: headerColorHex,
		textColor: textColorHex,
		buttonTextColor: buttonTextColorHex,
		buttonBackgroundColor: buttonBackgroundColorHex,
		socialIconsColor: socialIconsColorHex,
	};

	const renderContent = () => {
		return (
			<div className={`useImageBrowseWrapper`}>
				<Paper elevation={0} className={classes.boxContent}>
					<Formik
						initialValues={{
							contactForm: contactFormInitialValues,
							title,
						}}
						validationSchema={Yup.object({
							contactForm: contactFormYupSchema,
						})}
						onSubmit={async (values, { setSubmitting }) => {
							// showFormikValues(values, setSubmitting);
							await handleSave(values);
							setSubmitting(false);
						}}
					>
						{renderForm}
					</Formik>
				</Paper>
				<Box p={1} />
			</div>
		);
	};
	return (
		<GenericDialog
			shadedContent
			maxWidth="md"
			title={_e('contact')}
			subtitle={_e('contact_desc')}
			content={renderContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditContactSectionDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	sectionId: PropTypes.string,
};

export default EditContactSectionDialog;
